module.exports = __webpack_public_path__ + "static/media/draw-polygon.2bf9097c.svg";